import { CURRENCY_DEFAULT } from '@/helper/constants';
import { convertMoneyToDefaultCurrency } from '@/helper/util';
import { action, makeObservable, observable } from 'mobx';

export default class AncillaryCHG1Store {
  @observable plainAddonItems: AACheckout.PlainAddonItem[] = [];
  @observable conversionRates: AACheckout.ConversionRates;
  @observable totalAmount = 0;

  constructor() {
    makeObservable(this);
  }

  @action
  updateData = async (
    autoApplySSRData: AACheckout.AutoApplySSRData,
    conversionRates: AACheckout.ConversionRates,
  ) => {
    if (!autoApplySSRData) return;
    this.conversionRates = conversionRates;
    this.totalAmount = this.calcAmount(autoApplySSRData);
    this.plainAddonItems = this.generatePlainAddonItems(autoApplySSRData);
  };

  @action
  calcAmount = (autoApplySSRData: AACheckout.AutoApplySSRData) => {
    let totalAmount = 0;
    autoApplySSRData.data.map((item) => {
      const chg1Item = item.ancillarylist.autoApplySSR[0];
      if (chg1Item) {
        totalAmount += convertMoneyToDefaultCurrency(
          chg1Item.price.slashedPrice,
          autoApplySSRData.currency,
          this.conversionRates,
        );
      }
    });

    return totalAmount;
  };

  @action
  generatePlainAddonItems = (autoApplySSRData: AACheckout.AutoApplySSRData) => {
    const items: AACheckout.PlainAddonItem[] = [];

    autoApplySSRData.data.map((item) => {
      const chg1Item = item.ancillarylist.autoApplySSR[0];

      if (chg1Item) {
        items.push({
          id: chg1Item.id,
          groupBy: 'chg1',
          currency: CURRENCY_DEFAULT,
          name: chg1Item.properties.name,
          price: convertMoneyToDefaultCurrency(
            chg1Item.price.slashedPrice,
            autoApplySSRData.currency,
            this.conversionRates,
          ),
          type: 'chg1',
          category: 'CHG1',
          departureStation: item.designator.departureStation,
          arrivalStation: item.designator.arrivalStation,
          properties: {},
          passengerReferenceId: '',
        });
      }
    });

    return items;
  };
}
